export default __webpack_public_path__ + "ec5307044f561bd0e346d2a1d9139d4e.svg";